export default __webpack_public_path__ + "static/media/close-button.b1f1ca83.svg";